import { BankAccountsResponse } from '@/types/sso';
import { Fragment } from 'react';

export interface SSIProfileBankDetailsProps {
    ssiProfile?: BankAccountsResponse;
}

const SSIProfileBankDetails = (props: SSIProfileBankDetailsProps) => {
    const { ssiProfile } = props;
    return (
        <Fragment>
            {ssiProfile ? (
                <div className="text-xs text-brand-primary-light flex flex-col gap-5 p-3 bg-brand-background-dark rounded-md">
                    {/* TBA - Translations*/}
                    <div>Standard Settlement Instructions:</div>
                    <div className="text-xs text-brand-neutral-200">
                        <div className="flex flex-col gap-5">
                            <div className="flex flex-col gap-2">
                                <div className="text-brand-neutral-500">Bank Details</div>
                                <div className="grid grid-cols-2 gap-2">
                                    {ssiProfile.beneficiaryName && (
                                        <Fragment>
                                            <div>Beneficiary Name</div>
                                            <div>{ssiProfile.beneficiaryName}</div>
                                        </Fragment>
                                    )}
                                    <div>Bank Name</div>
                                    <div>{ssiProfile.bankName}</div>
                                    <div>IBAN Code</div>
                                    <div>{ssiProfile.ibanCode}</div>
                                    <div>SWIFT Code</div>
                                    <div>{ssiProfile.swiftCode}</div>
                                </div>
                            </div>
                            {ssiProfile.correspondentBankName && ssiProfile.correspondentBankSwiftCode && (
                                <div className="flex flex-col gap-2">
                                    <div className="text-brand-neutral-500">Correspondent Bank Details</div>
                                    <div className="grid grid-cols-2 gap-2">
                                        <div>Bank Name</div>
                                        <div>{ssiProfile.correspondentBankName}</div>
                                        <div>SWIFT Code</div>
                                        <div>{ssiProfile.correspondentBankSwiftCode}</div>
                                    </div>
                                </div>
                            )}
                            {ssiProfile.intermediaryBankName && ssiProfile.intermediaryBankSwiftCode && (
                                <div className="flex flex-col gap-2">
                                    <div className="text-brand-neutral-500">Intermediary Bank Details</div>
                                    <div className="grid grid-cols-2 gap-2">
                                        <div>Bank Name</div>
                                        <div>{ssiProfile.intermediaryBankName}</div>
                                        <div>SWIFT Code</div>
                                        <div>{ssiProfile.intermediaryBankSwiftCode}</div>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                    <div className="text-xs text-brand-primary-light">
                        {/* TBA - Translations */}
                        Please transfer funds <b>ONLY</b> from whitelisted bank accounts to the account listed below.
                        Funds from non whitelisted accounts cannot be accepted.
                    </div>
                </div>
            ) : (
                <div className="text-xs text-brand-primary-light flex flex-col gap-3 p-3 bg-brand-background-dark rounded-md">
                    {/* TBA - Translations */}
                    <div>Standard Settlement Instructions:</div>
                    <div className="text-xs text-brand-neutral-200">
                        Please contact support to set up your deposit request.
                    </div>
                </div>
            )}
        </Fragment>
    );
};

export default SSIProfileBankDetails;
